import { decode } from 'html-entities';

export const getEnv = () => {
  return JSON.parse(process.env);
};

/**
 * local 여부
 * @returns {boolean}
 */
export const isLocal = () => {
  return window.location.hostname.includes('local');
};

/**
 * unescape html(xss)
 * @param {*} value
 * @returns
 */
export const unescapeHtml = (value) => {
  return decode(value).replace(/amp;/g, '');
};

/**
 * 문자 개행 처리
 * @param {*} value
 * @returns
 */
export const replaceNewLine = (value) => {
  return unescapeHtml(value.replace(/(?:\r\n|\r|\n)/g, '<br />'));
};

/**
 * Empty 검사
 * @param data
 * @returns {boolean}
 */
export const isEmpty = (data) => {
  if (data === null || data === 'null' || undefined === data || data === 'undefined' || data === '') {
    return true;
  }

  return false;
};

/**
 * 1000단위 콤마
 * @param {number} str
 * @returns {string}
 */
export const comma = (str) => {
  if (isEmpty(str)) {
    return '';
  }
  return str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const errorMsg = (error) => {
  const { response } = error;

  // 에러 여부
  if (undefined !== response && response.status !== 200) {
    const { data, status } = response;
    const { resultMessage } = data;
    let message = '';

    if (status === 401) {
      message = `가입 정보가 없거나, 일치하지 않습니다. (${resultMessage})`;
    } else if (status === 500) {
      switch (resultMessage) {
        case 'ERR_REQUEST_AUTH_FAIL':
          message = `입력하신 정보를 확인 후 다시 시도해 주세요. (${resultMessage})`;
          break;
        default:
          if (resultMessage !== null) {
            message = `처리 중 오류가 발생하였습니다. (${resultMessage})`;
          } else {
            message = `처리 중 오류가 발생하였습니다.`;
          }
          break;
      }
    } else if (status === 504) {
      message = `통신이 원활하지 않습니다. (${status})`;
    } else {
      // console.log(status);
      return;
    }

    alert(message);
  }
};
